import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core'
import { ComponentState } from '@app/models/shared.model'
import { MyTreeComponent } from '../myTree/myTree.component'
import { FormGroup } from '@angular/forms'
import { BranchWithStatus } from '@app/models/branch.model'
import { BranchService } from '@app/modules/authorized/services/branch.service'
import { Area } from '@app/models/area.model'
import { indexOf } from 'lodash-es'

@Component({ selector: 'app-allowed-permissions', templateUrl: './allowed-permissions.component.html', styleUrls: ['./allowed-permissions.component.scss'], standalone: false })
export class AllowedPermissionsComponent implements AfterViewChecked, OnChanges {
  /** Tree reference for "update state" (create/edit) control filter/collapse... */
  @ViewChild('updateTreeRef') updateTreeRef: MyTreeComponent

  /** Tree reference for "details state" control filter/collapse... */
  @ViewChild('detailsTreeRef') detailsTreeRef: MyTreeComponent

  /** Form group input */
  @Input() form: FormGroup

  /** Invitation model */
  @Input() model: any = {}

  /** Selected object */
  @Input() selectedObject: any

  /** Component state */
  @Input() state: ComponentState

  /** Container classes */
  @Input() classes: string = 'offset-top mt-5 mb-5 pd-16'

  /** Card height input */
  @Input() cardHeight: any = 'calc(100vh - 355px)'

  /** Selected checkbox entrance for bind */
  selectedEntrance: BranchWithStatus

  /** Areas array */
  areas: any[] = []

  /** Selected areas */
  selectedAreas: any[] = []

  /** Expanded state */
  expanded: boolean

  constructor(public cdRef: ChangeDetectorRef, private branchService: BranchService) {}

  ngAfterViewChecked() {
    this.expanded = this.state != 'details' ? this.updateTreeRef?.isExpanded : this.detailsTreeRef?.isExpanded
    this.cdRef.detectChanges()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['state']?.currentValue == 'edit' || changes['selectedObject']?.currentValue != changes['selectedObject']?.previousValue) {
      this.updateTreeAndAreasData(this.selectedObject)
      if (this.state == 'edit') this.updateEntrancesAndAreasInput()
    }
  }

  get entrances() {
    return this.selectedObject?.entrances.filter((e: any) => e.name != 'event_unused_entrance')
  }

  get filteredAreas() {
    return this.areas?.filter((v) => v.active)
  }

  get stringAreas() {
    return this.model?.areas.map((v: number | string) => v.toString())
  }

  /**
   * Expand all pr collapse all tree
   * @param e For prevent default
   */
  expandOrCollapseAll(e: Event) {
    e.preventDefault()
    if (this.state != 'details') {
      if (this.updateTreeRef.isExpanded) {
        this.updateTreeRef.collapseAll()
      } else {
        this.updateTreeRef.expandAll()
      }
    } else {
      if (this.detailsTreeRef.isExpanded) {
        this.detailsTreeRef.collapseAll()
      } else {
        this.detailsTreeRef.expandAll()
      }
    }
  }

  /**
   * Node selection changed update areas array
   * @param node Selection node
   */
  nodeSelectionChanges(node: any) {
    const currentEntrance = this.entrances?.find((entrance: any) => entrance.id.toString() == node.data.id.toString())
    this.selectedEntrance = currentEntrance
    this.areas = currentEntrance?.areas
  }

  /**
   * Node checkbox selection changed
   * @param select The select
   */
  nodeCheckBoxSelection(node: any, select: boolean, updateState?: boolean) {
    if (node) {
      const currentEntrance = this.entrances?.find((entrance: any) => entrance.id.toString() == node.data.id.toString())

      if (this.updateTreeRef.propagateSelectionUp)
        //if (currentEntrance.parent_id)
        this.selectOrUnselectAllParentAreas(currentEntrance, select, updateState)

      const sub = this.entrances?.find((entrance: any) => entrance.id.toString() == currentEntrance.id.toString())

      if (/* sub.subEntrances?.length &&  */ !updateState) {
        sub.areas.forEach((area: any) => {
          this.updateSelectedAreasList(area, select)
        })

        if (this.updateTreeRef.propagateSelectionDown)
          sub.subEntrances.forEach((subEntrance: any) => {
            this.selectOrUnselectAllChildrenAreas(subEntrance, select, updateState)
          })
      }

      this.form.get('areas')!.setValue(this.selectedAreas)
      this.nodeSelectionChanges(node)
    }
  }

  /**
   * When select or unselect all entrances update selected areas object for parent
   * @param entrance
   * @param select
   */
  selectOrUnselectAllParentAreas(entrance: any, select: boolean, updateState?: boolean) {
    if (entrance) {
      if (!updateState) {
        entrance?.areas?.forEach((area: any) => {
          this.updateSelectedAreasList(area, select)
        })
      } else {
        const selectedAreasToAdd = entrance.areas.filter((area: any) => this.model.areas?.includes(Number.parseInt(area.id)))
        selectedAreasToAdd?.forEach((area: any) => {
          this.updateSelectedAreasList(area, select)
        })
      }
      if (entrance.parent_id) {
        const parentEntrance = this.entrances?.find((_entrance: any) => _entrance.id.toString() == entrance.parent_id[0].toString())
        this.selectOrUnselectAllParentAreas(parentEntrance, select, updateState)
      }
    }
  }

  /**
   * When select or unselect all entrances update selected areas object for children
   * @param entrance
   * @param select
   */
  selectOrUnselectAllChildrenAreas(entrance: any, select: boolean, updateState?: boolean) {
    const currentEntrance = this.entrances?.find((e: any) => e.id.toString() == entrance.id.toString())

    if (currentEntrance) {
      if (!updateState)
        currentEntrance.areas.forEach((area: any) => {
          this.updateSelectedAreasList(area, select)
        })
      else {
        const selectedAreasToAdd = entrance.areas.filter((area: any) => this.model.areas?.includes(Number.parseInt(area.id)))

        selectedAreasToAdd?.forEach((area: any) => {
          this.updateSelectedAreasList(area, select)
        })
      }
      currentEntrance.subEntrances.forEach((subEntrance: any) => {
        this.selectOrUnselectAllChildrenAreas(subEntrance, select, updateState)
      })
    }
  }

  updateSelectedAreasList(area: Area, select: boolean) {
    const index = this.selectedAreas.findIndex((_area: any) => _area.id.toString() == area.id.toString())
    if (select && !this.selectedAreas.find((v) => v?.id?.toString() == area?.id?.toString())) {
      this.selectedAreas.push(area)
    } else if (!select) {
      if (index > -1) this.selectedAreas.splice(index, 1)
    }
  }

  /**
   * Area selection changes, update entrances tree selection
   * @param selectedAreas
   */
  areaSelectionChanges(selectedAreas: any, isUpdateState?: boolean) {
    const selectedAreasIds = selectedAreas.map((area: any) => area?.id?.toString())
    const areasSelected = this.areas.filter((area: any) => selectedAreasIds.includes(area.id.toString()))
    const currentArea = selectedAreas[selectedAreas.length - 1]

    if (areasSelected?.length == this.areas?.length || !areasSelected.length) {
      if (this.updateTreeRef.propagateSelectionDown) {
        this.updateTreeRef.treeReference.propagateDown(this.updateTreeRef.currentNode, areasSelected.length ? true : false)
      }

      if (this.updateTreeRef.propagateSelectionUp /*  && this.updateTreeRef.currentNode.parent */) {
        const currentSelection: any[] = (this.updateTreeRef.treeReference.selection as any)() ?? []
        if (indexOf(currentSelection, this.updateTreeRef.currentNode) == -1) {
          ;(this.updateTreeRef.treeReference.selection as any).set([...currentSelection, this.updateTreeRef.currentNode])
        }

        if (this.updateTreeRef.propagateSelectionUp) this.updateTreeRef.treeReference.propagateUp(this.updateTreeRef.currentNode, areasSelected.length ? true : false)
      }

      this.updateTreeRef.selection = (this.updateTreeRef.treeReference.selection as any)()
      if (!areasSelected.length) this.updateTreeRef.selection = this.updateTreeRef.selection.filter((v: any) => v != this.updateTreeRef.currentNode)
      this.updateTreeRef.currentNode.partialSelected = false

      this.nodeCheckBoxSelection(this.updateTreeRef?.currentNode, areasSelected.length == this.updateTreeRef?.currentNode.data?.obj?.areas?.length)
    } else {
      if (this.updateTreeRef.propagateSelectionDown) this.updateTreeRef.treeReference.propagateDown(this.updateTreeRef.currentNode, false)
      if (this.updateTreeRef.propagateSelectionUp) this.updateTreeRef.treeReference.propagateUp(this.updateTreeRef.currentNode, false)

      this.updateTreeRef.currentNode.partialSelected = this.areas.length > areasSelected?.length

      this.updateSelectedAreasList(currentArea, !isUpdateState ? selectedAreas?.length > this.selectedAreas.length : this.areas.length > selectedAreas?.length)
    }

    this.updateTreeRef.selection = this.updateTreeRef.selection.filter(function (elem: any, index: any, self: any) {
      return index === self.indexOf(elem)
    })
  }

  /**
   * Update entrances and areas input when edit mode or from parent component
   */
  updateEntrancesAndAreasInput() {
    if (!this.branchService.getAreasArrayByIdsArray(this.model, this.form.get('domain')?.value))
      this.form.get('areas')!.setValue(this.branchService.getAreasArrayByIdsArray(this.model, this.form.get('domain')?.value))
    const selectedAreas: any[] = []

    this.selectedObject.entrances?.forEach((entrance: any) => {
      if (entrance.name != 'event_unused_entrance') {
        const selectedAreasToAdd = entrance.areas.filter((area: any) => this.model.areas?.includes(Number.parseInt(area.id)))
        if (selectedAreasToAdd?.length) selectedAreas.push(...selectedAreasToAdd)
      }
    })

    this.updateTreeRef?.serializedValues?.forEach((node: any) => {
      const areas = node.data.obj.areas?.filter((val: any) => selectedAreas.includes(val))
      this.updateTreeRef.currentNode = node
      this.selectedEntrance = node.data
      if (areas.length) {
        this.areas = this.updateTreeRef.currentNode.data.obj.areas
        this.areaSelectionChanges(areas, true)
      }
    })
    this.form.get('areas')!.setValue(this.selectedAreas)
  }

  /**
   * Update tree and areas data
   * @param value
   */
  updateTreeAndAreasData(value: any) {
    this.selectedObject = value
    this.selectedEntrance = this.entrances ? this.entrances[0] : null
    this.areas = this.selectedEntrance?.areas
    this.selectedAreas = []

    if (!value) {
      if (this.state != 'details') {
        this.updateTreeRef.data = []
      } else {
        this.detailsTreeRef.data = []
      }
    }

    if (this.state != 'details' && this.updateTreeRef) {
      if (this.state == 'create') {
        this.updateTreeRef.data = this.entrances ? [...this.entrances] : []
        this.updateTreeRef?.initNodes()
        this.updateTreeRef.currentNode = this.updateTreeRef.nodes[0]
      } else {
        this.updateTreeRef.currentNode = this.updateTreeRef.nodes[0]
        this.updateTreeRef.expandAll()
      }
    } else {
      this.detailsTreeRef?.initNodes()
    }
  }
}
